import { render, staticRenderFns } from "./SaveCurve.vue?vue&type=template&id=708624ca&scoped=true"
import script from "./SaveCurve.vue?vue&type=script&lang=js"
export * from "./SaveCurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708624ca",
  null
  
)

export default component.exports